'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Children, cloneElement, Fragment, isValidElement, useEffect, useId, useMemo, useRef, useState, } from 'react';
export const StickySpy = ({ children, onStickyChange, attribute = 'data-react-is-sticky', root, }) => {
    const defaultRoot = useMemo(() => (root ?? (typeof document !== 'undefined' ? document : null)), [root]);
    const spyRef = useRef(null);
    const [isSticky, setIsSticky] = useState(false);
    const uid = useId();
    useEffect(() => {
        const spy = spyRef.current;
        const observer = new IntersectionObserver(([entry]) => {
            setIsSticky(!entry.isIntersecting);
            onStickyChange?.(!entry.isIntersecting);
        }, {
            root: defaultRoot,
        });
        if (spy) {
            observer.observe(spy);
        }
        return () => (spy ? observer.unobserve(spy) : undefined);
    }, [children, spyRef, onStickyChange, defaultRoot]);
    return (_jsxs(Fragment, { children: [_jsx("div", { ref: spyRef, "data-react-sticky-spy": true, style: { height: 0, width: 1 } }), Children.map(children, child => (isValidElement(child) ? cloneElement(child, { [attribute]: isSticky }) : child))] }, uid));
};
